import React, { ComponentProps, FC } from 'react';

import { Alert } from 'app/components/alert';
import { AlertType } from 'app/components/alert/alert-type';
import { i18n } from 'app/i18n';
import { objectDeepFreeze } from 'app/utils/object-utils';

type AlertProps = ComponentProps<typeof Alert>;

type HomeGatewayUpgradeAlertProps = Omit<AlertProps, keyof typeof HOME_GATEWAY_UPGRADE_ALERT_PROPS>;

const HOME_GATEWAY_UPGRADE_ALERT_PROPS: Pick<AlertProps, 'title' | 'text' | 'type'> = objectDeepFreeze({
    title: i18n.components.homeGatewayUpgradeAlert.title,
    text: i18n.components.homeGatewayUpgradeAlert.text,
    type: AlertType.INFO,
});

export const HomeGatewayUpgradeAlert: FC<HomeGatewayUpgradeAlertProps> = (props) => (
    <Alert {...props} {...HOME_GATEWAY_UPGRADE_ALERT_PROPS} />
);
